import React from "react";
import ProjectCard from "./ProjectCards";
import Reveal from "../ui/Reveal";
import SectionHeading from "../ui/SectionHeading";
import { PROJECTS, SOCIALS } from "../../data/portfolio";
import { BsGithub } from "react-icons/bs";

const GITHUB = SOCIALS.find((s) => s.icon === "github")?.href || "#";

function Projects() {
  return (
    <section id="projects" className="section">
      <div className="container-page flex flex-col gap-14">
        <SectionHeading
          kicker="Projects"
          title="Things I've built"
          subtitle="A selection of recent work across web apps, APIs, IoT and machine learning."
        />

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {PROJECTS.map((project, i) => (
            <Reveal
              key={project.title}
              delay={(i % 2) * 80}
              className={`flex ${project.featured ? "md:col-span-2" : ""}`}
            >
              <ProjectCard project={project} />
            </Reveal>
          ))}
        </div>

        <Reveal className="flex justify-center">
          <a
            href={GITHUB}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-ghost"
          >
            <BsGithub /> More on GitHub
          </a>
        </Reveal>
      </div>
    </section>
  );
}

export default Projects;
